import { memo } from "react";
import { cn } from "utils";
import { I18nUtil } from "@utils";
import Translations from "@translate/components/Watchlist/CexBadge";

const I18n = I18nUtil.createScoped(Translations);

const CexBadge = memo(() => {
  return (
    <span
      className={cn(
        "flex items-center justify-center h-fit",
        "px-1 py-0.5",
        "rounded border border-content_brand_primary/20",
        "bg-content_brand_primary/5",
        "backdrop-blur-[10px]",
        "ml-2 body_medium_xs text-content_brand_primary/80",
      )}
    >
      {I18n.t("CEX")}
    </span>
  );
});
CexBadge.displayName = "CexBadge";

export default CexBadge;
